module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-referee-b4fee85bc01d20814b1d5798d954cd31.svg";